import request from '../../axios/axiosconfig.js'

export function bcCapitalDetail(params) {
  return request({
    url: '/ps/bsCapitalDetail/bsCapitalDetail',
    method: 'get',
    params: params
  })
}
export function getFrozen(params) {
  return request({
    url: '/ps/bsCapitalDetail/getFrozen/'+params,
    method: 'get'
  })
}
export function getWithdrawByBsId(page,bsId) {
  return request({
    url: '/ps/bsCapitalDetail/getWithdrawByBsId/'+bsId,
    method: 'get',
    params: page
  })
}
export function operationAccount(data) {
  return request({
    url: '/ps/bsStoreRelation/operationAccount',
    method: 'post',
    data: data
  })
}
export function frozenBalance(data) {
  return request({
    url: '/ps/bsCapitalDetail/frozenBalance',
    method: 'post',
    data: data
  })
}

export function bsCapitalDetailExport(data) {
  return request({
    url: '/ps/bsCapitalDetail/bsCapitalDetailExport',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/accountFunds/bsfundsdetail.js